import { mountedComponentReducer as mountedComponents } from './mountedComponents/mountedComponents.reducers'
import { configReducer as config } from './config/config.reducers'
import { userDeviceReducer as userDevice } from './userDevice/userDevice.reducers'
import { featureFlagReducer as featureFlag } from './featureFlags/featureFlags.reducers'
import { shareButtonsReducers as shareButtons } from './shareButtons/shareButtons.reducers'
import { currentUserReducer as currentUser } from './currentUser/currentUser.reducers'
import { messageUserReducer as messageUser } from './messageUser/MessageUser.reducers'
import { userStatsReducer as userStats } from './userStats/Stats.reducers'
import { logoReducer as logo } from './logo/logo.reducers'

export const reducers = {
  mountedComponents,
  config,
  userDevice,
  featureFlag,
  shareButtons,
  currentUser,
  messageUser,
  userStats,
  logo,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/reducers.js